export default "__VITE_ASSET__54fc1dcf__"